import { request } from '../utils/request';

export const fetchUserList = () => request.get(`/users`);
export const fetchUserStatus = params =>
  request.get(`/slack-status`, {
    params: {
      user: params.userId,
      page: params.pageNum
    }
  });



// WEBPACK FOOTER //
// ./src/api/users.js